/**
 * Resolves the API base URL at runtime.
 *
 * Why this exists:
 *   `REACT_APP_BACKEND_URL` is baked into the JS bundle at build time. When the
 *   same build is deployed to multiple environments (e.g., preview AND
 *   production at homecontrol.in), API calls would still go to the URL that
 *   existed at build time — causing the browser to show the wrong origin in
 *   download bars and breaking environment isolation.
 *
 * Resolution:
 *   If the page's host differs from the env URL's host, use the page's own
 *   origin (same-origin). Otherwise use the env URL. Empty when neither is
 *   available (e.g., SSR).
 */
export const apiOrigin = () => {
  const envUrl = process.env.REACT_APP_BACKEND_URL || '';
  if (typeof window === 'undefined') return envUrl;
  try {
    const pageHost = window.location.host;
    const envHost = envUrl ? new URL(envUrl).host : '';
    if (envHost && pageHost && pageHost !== envHost) {
      return window.location.origin;
    }
  } catch { /* ignore parse errors */ }
  return envUrl;
};

export const apiBase = () => `${apiOrigin()}/api`;
